<template>
    <div class="dropdown" @mouseover="isOpen = true" @mouseleave="isOpen = false" @click="isOpen = true">  
        <a href="/domatia/" class="button-dropdown el" v-if="!isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"/></svg>
        </a>
        <a href="/domatia/" class="button-dropdown el" v-if="isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.39 265.4l127.1-128C143.6 131.1 151.8 128 160 128s16.38 3.125 22.63 9.375l127.1 128c9.156 9.156 11.9 22.91 6.943 34.88S300.9 320 287.1 320H32.01c-12.94 0-24.62-7.781-29.58-19.75S.2333 274.5 9.39 265.4z"/></svg>
        </a>
        <transition name="slide-up" appear>
            <div class="sidebar-drop" v-if="isOpen">
                <div class="side-cont">
                <div class="menu-col"> 
                    <div class="default-text is-hovered">
                        <p class="el firsttext">Γνωρίζοντας τις ανάγκες των πελατών μας και για  τη καλύτερη εξυπηρέτηση τους κυρίως όταν πρόκειται για οικογένειες, έχουμε δημιουργήσει αυτά τα καταλύματα  που αποτελούνται από τέσσερις αυτοτελής μεζονέτες  με μικρά διαμερίσματα δύο δωματίων το καθένα έτσι ώστε κάθε οικογένεια με τα παιδιά της να είναι αυτόνομη.</p>
                        <p class="el secondtext">Η κατασκευή των κτιρίων είναι προσεγμένη με σύγχρονα υλικά υψηλής ποιότητας. Θερμομόνωση,  ηχομόνωση, σύστημα πυρόσβεσης και ασφαλή διαβίωση. Βρίσκονται στη περιοχή Μυκονιάτικα στη Ν. Καλλικράτεια Χαλκιδικής  σε ιδιόκτητο οικόπεδο με κήπο και έχουν όλα θέα στη θάλασσα.</p>
                    </div>
                    <div class="dom1-text">
                        <p class="el firsttext">Για την άνεση και την ευχάριστη διαμονή των επισκεπτών μας, οι άσπρες σουίτες έχουν σχεδιαστεί ώστε να προσφέρουν πλήρη αυτονομία. Κάθε σουίτα αποτελείται από δύο υπνοδωμάτια και έναν ευρύχωρο χώρο καθιστικού, ιδανικό για οικογένειες που θέλουν να απολαύσουν τις διακοπές τους με άνεση και ιδιωτικότητα.</p>
                        <p class="el secondtext">Οι άσπρες σουίτες συνδυάζουν κομψότητα και λειτουργικότητα, με ευρύχωρα υπνοδωμάτια και άνετο καθιστικό για όλη την οικογένεια. Κάθε σουίτα διαθέτει πλήρως εξοπλισμένη κουζίνα και φωτεινούς χώρους, ενώ οι μεγάλες βεράντες προσφέρουν θέα στη θάλασσα, δημιουργώντας το ιδανικό περιβάλλον για στιγμές χαλάρωσης και απόλαυσης των διακοπών.</p>
                    </div>
                    <div class="dom2-text">
                        <p class="el firsttext">Για την άνεση και την ευχάριστη διαμονή των επισκεπτών μας, οι ροζ σουίτες έχουν σχεδιαστεί ώστε να προσφέρουν πλήρη αυτονομία. Κάθε σουίτα διαθέτει δύο υπνοδωμάτια και έναν άνετο χώρο καθιστικού, προσφέροντας ιδανική λύση για οικογένειες που θέλουν να απολαύσουν τις διακοπές τους με άνεση και ιδιωτικότητα.</p>
                        <p class="el secondtext">Η κατασκευή των ροζ σουιτών είναι προσεγμένη με σύγχρονα υλικά υψηλής ποιότητας, εξασφαλίζοντας θερμομόνωση, ηχομόνωση και ασφαλή διαβίωση. Βρίσκονται στην περιοχή Μυκονιάτικα στη Ν. Καλλικράτεια Χαλκιδικής, σε ιδιόκτητο οικόπεδο με κήπο, και όλες οι σουίτες προσφέρουν μαγευτική θέα στη θάλασσα.</p>
                    </div>
                    <div class="dom3-text">
                        <p class="el firsttext">Για την άνεση και την ευχάριστη διαμονή των επισκεπτών μας, οι μπλε σουίτες έχουν σχεδιαστεί ώστε να προσφέρουν πλήρη αυτονομία. Κάθε σουίτα διαθέτει δύο υπνοδωμάτια και έναν ευρύχωρο χώρο καθιστικού, προσφέροντας ιδανική λύση για οικογένειες που θέλουν να απολαύσουν τις διακοπές τους με άνεση και ιδιωτικότητα.</p>
                        <p class="el secondtext">Η κατασκευή των μπλε σουιτών είναι προσεγμένη με σύγχρονα υλικά υψηλής ποιότητας, εξασφαλίζοντας θερμομόνωση, ηχομόνωση και ασφαλή διαβίωση. Βρίσκονται στην περιοχή Μυκονιάτικα στη Ν. Καλλικράτεια Χαλκιδικής, σε ιδιόκτητο οικόπεδο με κήπο, και όλες οι σουίτες προσφέρουν μαγευτική θέα στη θάλασσα.</p>
                    </div>
                </div>
                <div class="menu-col1 el">
                    <div class="img-text firstimg">
                        <a href="/aspres-souites-tetraklines/"><img src="/wp-content/uploads/2026/02/DSC_3390-scaled.jpg" alt=""/></a>
                        <div class="title-text"> 
                            <a href="/aspres-souites-tetraklines/">ΑΣΠΡΕΣ ΣΟΥΙΤΕΣ ΤΕΤΡΑΚΛΙΝΕΣ</a>
                            <p>125-155€ | 4 ΚΛΙΝΕΣ | ΘΕΑ ΣΤΗ ΘΑΛΑΣΣΑ</p>
                        </div>
                    </div>
                    <div class="img-text secondimg">
                        <a href="/roz-souites-tetraklines/"><img src="/wp-content/uploads/2026/02/a36-1-scaled.jpg" alt=""/></a>
                        <div class="title-text"> 
                            <a href="/roz-souites-tetraklines/">ΡΟΖ ΣΟΥΙΤΕΣ ΤΕΤΡΑΚΛΙΝΕΣ</a>
                            <p>135-185€ | 4 ΚΛΙΝΕΣ | ΘΕΑ ΣΤΗ ΘΑΛΑΣΣΑ</p>
                        </div>
                    </div>
                    <div class="img-text thirdimg">
                        <a href="/mple-souites-tetraklines/"><img src="/wp-content/uploads/2026/02/a28-scaled.jpg" alt=""/></a>
                        <div class="title-text"> 
                            <a href="/mple-souites-tetraklines/">ΜΠΛΕ ΣΟΥΙΤΕΣ ΤΕΤΡΑΚΛΙΝΕΣ</a>
                            <p>155-195€ | 4 ΚΛΙΝΕΣ | ΘΕΑ ΣΤΗ ΘΑΛΑΣΣΑ</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </transition>
    </div>
</template>


<script>

export default ({
    name: 'sidebar-right',
    props: ['title', 'items','itemsen','titlen'],
    data () {
        return{
            isOpen: false,
            secondTime: true
        }
    }
})

</script>

<style>
.img-text{
    display: flex;
    gap:15px !important;
    padding-left: 40px;
    margin-bottom: 25px;
}
.menu-col{
    width: 65% !important;
    padding-top: 50px !important;
    padding-left: 240px !important;
}

.menu-col1{
    width: 35% !important;
    padding-right: 240px !important;
    border-left: 1px solid #e5e5e5;
    padding-top: 50px;
    padding-bottom: 25px;
}
.menu-item1{
    display: flex;
}

    .dropdown{
        text-align: center;
    }
    .button-dropdown {
        font-size: 40px;
        text-decoration: none;
        color:#222 !important;
        display: inline-block;
        position: relative;
    }
 
 .button-dropdown:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #222;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.button-dropdown:hover:after{
  transform: scaleX(1);
  transform-origin: bottom left;
}
    .button-dropdown svg{
        margin-left: 10px;
        width:15px !important;
        filter:none !important;
    }
    .menu-item svg{
        width:10px !important;
        
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .sidebar-drop img{
        width: 120px !important;
        height: 90px !important;
        object-fit: cover;
        border-radius: 5px !important;
    }
    .sidebar-drop{
        border-top: 1px solid #e7e7e7;
        background-color: #fffdfd;
        width:100% !important;
        z-index: 99;
        box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);
        margin-left: auto;
        margin-right: auto;
        text-align: left;
        padding: 0px 0;
        margin-top: 20px;
        overflow: scroll;
        display: flex;
        overflow-x: hidden;
    }
 

   
    .sidebar-drop .menu-item1 {
        font-size: 20px;
        padding: 9px 40px;
        font-weight: 600;
    }

    .sidebar-drop .menu-item1 a{
       text-align: left;
       text-decoration: none;
       color:#222;
       display: inline-block;
       padding-bottom:5px;
       position: relative;
    }
    .title-text a{
        text-decoration: none;
        color:#222 !important
    }
    .title-text a:hover{
        color:#719452 !important
    }
    /* .sidebar-drop .menu-item1 a:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #222;
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }*/

    .sidebar-drop .menu-item1 a:hover:after{
        transform: scaleX(1);
        transform-origin: bottom left;
    }
    .sidebar-drop.menu-item1:hover{
        background-color: #fff;
        color:#222;     
    }
    .sidebar-drop .menu-item1 a:hover{
        color:#719452 !important
    }
    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: all 0.4s ease-out;
    }

.slide-up-enter,.slide-up-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
/*
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}*/

@media only screen and (max-width: 767px) {
    nav .menu-item1 .sidebar{
        width:100% !important;
    }
}

</style>